import PropTypes from 'prop-types';
import Box from '@quintoandar/cozy-core/Box';
import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { FileUploader } from './FileUploader';
import { VideoPreviewContainer } from './VideoPreviewContainer/VideoPreviewContainer';

export const VideoUploaderContainer = ({ houseId, vimeoLink, vimeoVideoId, vimeoStatus }) => {
  const queryClient = useQueryClient();

  const refetchVideoLinks = () => {
    queryClient.invalidateQueries('retrieveAllVideoLinks');
  };

  const shouldPoll = () => {
    const uploadDidNotBegan = vimeoStatus === 'signed_url_created';
    if (!vimeoStatus || uploadDidNotBegan) {
      return false;
    }

    const transcodeDidNotFinish = vimeoStatus !== 'transcode_complete';
    return transcodeDidNotFinish;
  };

  if (vimeoLink && vimeoStatus === 'transcode_complete') {
    return (
      <VideoPreviewContainer videoLink={vimeoLink} videoId={vimeoVideoId} onVideoDeleted={refetchVideoLinks} />
    );
  }

  return (
    <Box>
      <FileUploader
        houseId={houseId}
        onVideoLinkUpdate={refetchVideoLinks}
        shouldPoll={shouldPoll()}
      />
    </Box>
  );
};

VideoUploaderContainer.propTypes = {
  houseId: PropTypes.string,
  vimeoLink: PropTypes.string,
  vimeoVideoId: PropTypes.string,
  vimeoStatus: PropTypes.string,
};
